import { useTranslations } from 'next-intl';

import ReviewLogo from '@/fo/icons/base/logos/review-logo.svg';
import { UiReviewTileProduct } from '@/fo/ui/review/tile/product';

import { Product } from '../../types';

import { styles } from './ReviewResponseCard.styles';

export interface ReviewResponseCardProps {
  text: string;
  recommendedProduct?: Product | null;
}

export function ReviewResponseCard({
  text,
  recommendedProduct
}: ReviewResponseCardProps) {
  const slots = styles();
  const t = useTranslations();

  return (
    <div className={slots.base()}>
      <div className={slots.header()}>
        <span>
          <ReviewLogo />
        </span>
        <span>{t('review.labels.naosRepresentative')}</span>
      </div>
      <p className={slots.text()}>{text}</p>
      {recommendedProduct && (
        <div className={slots.recommendedProduct()}>
          <UiReviewTileProduct
            color="secondary"
            title={recommendedProduct.title}
            url={recommendedProduct.url}
            tags={
              recommendedProduct.volume
                ? Array.isArray(recommendedProduct.volume)
                  ? recommendedProduct.volume
                  : [recommendedProduct.volume]
                : undefined
            }
            imageUrl={recommendedProduct.imageUrl}
          />
        </div>
      )}
    </div>
  );
}
